<template>
  <div class="alleat_footer">
    <div class="eat_footer">
      <div class="footer_container">
        <div class="top_box">
          <div class="top_left">
            <span class="title "><label>All</label> Eat</span>
            <p class="eat_logo" ></p>
            <p class="tips">
              All Eat is an online food delivery app helping local restaurants <br />
              and communities say no to 35% commissions to takeaway <br />
              platforms with Unbeatable food, price, and service.</p>
          </div>
          <div class="right_main">
            <h2>Download <br /> Our Mobile App</h2>
            <div class="down_imgs">
              <a
                href="https://play.google.com/store/apps/details?id=io.dcloud.uniAllEat&gl=GB"
              >
                <img
                  src="@/assets/images/google_download.png"
                  alt="play"
                  class="download"
                />
              </a>
              <a
                href="https://apps.apple.com/gb/app/all-eat-food-delivery-uk/id1603420846"
              >
                <img
                  src="@/assets/images/ios_download.png"
                  alt="play"
                  class="download"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="column-line">We All Eat Together</div>
        <div class="footer_main">
          <div class="main_details">
            <h2 class="detail_title">CUSTOMER SERVICE</h2>
            <h3 class="detail_item" @click="contactUs">Contact us</h3>
            <h3 class="detail_item" @click="earnPoints">Earn Points</h3>
            <h3 class="detail_item" @click="myAccount">My Account</h3>
            <h3 class="detail_item pointer" @click="gotoFaqs">FAQ</h3>
            <h3 class="detail_item" @click="seedFeedback">Send feedback</h3>
          </div>
          <div class="main_details">
            <h2 class="detail_title">TOP CUISINES</h2>
            <h3
              class="detail_item"
              v-for="item in foodTypeList"
              :key="item.cuisineId"
              @click="gotoPath(item)"
            >
              {{
                item.cuisineName
              }}
            </h3>
            <h3 class="detail_item" @click="gotoPath('')">View all cuisines</h3>
          </div>
          <div class="main_details">
            <h2 class="detail_title">EXPLORE LOCATION</h2>
            <h3 class="detail_item" @click="gotoLocation('London')">London</h3>
            <h3 class="detail_item" @click="gotoLocation('Manchester')">
              Manchester
            </h3>
            <h3 class="detail_item" @click="gotoLocation('Birmingham')">
              Birmingham
            </h3>
            <h3 class="detail_item" @click="gotoLocation('Leeds')">Leeds</h3>
            <h3 class="detail_item" @click="gotoLocation('Glasgow')">
              Glasgow
            </h3>
            <h3 class="detail_item" @click="gotoLocation('')">
              View all locations
            </h3>
          </div>
          <div class="main_details">
            <h2 class="detail_title">QUICK LINKS</h2>
            <h3 class="detail_item" @click="aboutUs">About Us</h3>
            <h3 class="detail_item" @click="partnerUs">Partner with us</h3>
            <h3 class="detail_item" @click="careers">Careers</h3>
            <h3 class="detail_item pointer" @click="gotoBlog">Blog</h3>
            <h3 class="detail_item" @click="gotoBlog">Gallery</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="footer_desc">
        <div class="top_box">
          <section class="left">
            <h3>Follow Us</h3>
            <ul class="ekit_social_media">
              <li class="elementor-repeater-item">
                <a
                  href="https://www.facebook.com/alleatdelivery"
                  class="facebook"
                >
                  <i
                    aria-hidden="true"
                    class="iconfont icon-facebookfacebook51"
                  ></i>
                </a>
              </li>
              <li class="elementor-repeater-item">
                <a href="https://twitter.com/alleat_app" class="twitter">
                  <i
                    aria-hidden="true"
                    class="iconfont icon-tuitetwitter44"
                  ></i>
                </a>
              </li>
              <li class="elementor-repeater-item">
                <a
                  href="https://www.linkedin.com/company/alleatapp"
                  class="linkedin"
                >
                  <i aria-hidden="true" class="iconfont icon-linkedin"></i>
                </a>
              </li>
              <li class="elementor-repeater-item">
                <a href="https://www.instagram.com/alleatapp/" class="2">
                  <i aria-hidden="true" class="iconfont icon-instagram"></i>
                </a>
              </li>
            </ul>
          </section>
          <section class="right">
            <ul class="paylist">
              <li>
                <i class="iconfont icon-xinyongqia"></i>
                <span>Pay by Card</span>
              </li>
              <li>
                <i class="iconfont icon-pound-sign"></i>
                <span>Pay by Cash</span>
              </li>
              <li>
                <i class="iconfont icon-paypal"></i>
                <span>Pay by PayPal</span>
              </li>
            </ul>
          </section>
        </div>
        <div class="footer_incs">
          <div class="incs_container">
            <div class="insc">
              © <span>{{ fullYear }}</span> All Eat App Network Technology Inc.
            </div>
            <p class="footer_links">
              &nbsp;
              <a @click="gotoPrivate"> Privacy Policy |</a>
              &nbsp;
              <a @click="gotoTermsAndCond">Terms and Conditions |</a>
              &nbsp;
              <a @click="gotoCookie"> Cookie Policy</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postGateway } from '@/request'
export default {
  name: "app-footer",
  data() {
    return {
      fullYear: "",
      foodTypeList: [],
    };
  },
  mounted() {
    this.fullYear = new Date().getFullYear();
    //分类
    this.getFoodType();
  },
  computed: {},
  methods: {
    getFoodType() {
      postGateway({
        url: "/customerWeb/index/popularCategory",
        method: "GET",
        data: {},
      }).then((res) => {
        this.foodTypeList = res.data;
        console.log(res, "res");
      });
    },
    contactUs() {
      window.open("https://alleatapp.net/contact-us/");
    },
    earnPoints() {
      window.open(
        "https://alleatapp.net/what-is-the-points-system-in-all-eat/"
      );
    },
    partnerUs() {
      window.open("https://alleatapp.net/become-patner/");
    },
    aboutUs() {
      window.open("/aboutUs");
    },
    careers() {
      window.open("https://alleatapp.net/careers/");
    },
    seedFeedback() {
      window.open("https://alleatapp.net/contact-us/");
    },
    gotoFaqs() {
      this.$router.push("/faqs");
    },
    myAccount() {
      this.$router.push("/accountManagement/personalDetails");
    },
    gotoCookie() {
      this.$router.push("/cookiePage");
    },
    gotoPrivate() {
      this.$router.push("/privatePage");
    },
    goHelp() {
      this.$router.push("/help");
    },
    gotoBlog() {
      window.open("https://alleatapp.net/blog/");
    },
    // TODO
    gotoPath(item) {
      item
        ? this.$router.push(`/takeaway/nearme/${item.cuisineName}`)
        : this.$router.push(`/takeaway/nearme/all`);
      sessionStorage.setItem("typeId", item ? item.cuisineId : "");
    },
    gotoLocation(item) {
      this.$router.push(`/takeaway/${item}`);
    },
    gotoGplay() {
      window.open(
        "https://play.google.com/store/apps/details?id=io.dcloud.uniAllEat&gl=GB"
      );
    },
    gotoApp() {
      window.open(
        "https://apps.apple.com/gb/app/all-eat-food-delivery-uk/id1603420846"
      );
    },
    gotoTermsAndCond() {
      this.$router.push("/termsConditions");
    },
  },
};
</script>
<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.alleat_footer {
  width: 100%;
  font-family: "Roboto", Sans-serif;
  .eat_footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: #acacab;
    color: #fff;
    background: #242222;
    .footer_container {
      width: 1120px;
      padding: 10px;
      .top_box {
        display: inline-flex;
        justify-content: space-between;
        width: 100%;
        padding-bottom: 20px;
        .top_left {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          padding-right: 45px;
          padding: 10px;
          color: $mainColor;
          font-size: 38px;
          font-weight: bold;
          .title {
            margin-bottom: 20px;
            margin-top: 10px;
            font-size: 41px;
            font-weight: bold;
            label {
              color: $greenColor;
              font-weight: bold;
            }
          }
          .eat_logo {
            margin-top: -10px;
            display: inline-block;
            width: 63px;
            height: 63px;
            margin-bottom: 24px;
            background-image: url("../assets/logo.png");
            background-size: cover;
            border-radius: 6px;
            cursor: pointer;
          }
          .tips {
            margin-bottom: 20px;
            color: #fff;
            font-family: "Roboto", Sans-serif;
            font-size: 16px;
            font-weight: 500;
            text-align: left;
          }
        }
        .right_main {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          h2 {
            margin-bottom: 20px;
            color: #fff;
            font-family: "Roboto", Sans-serif;
            font-size: 41px;
            font-weight: 600;
            text-align: center;
          }
          .down_imgs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            img {
              display: inline-block;
              width: 195px;
              height: 60px;
              margin-left: 30px;
            }
          }
        }
      }
      .el-divider--horizontal {
        height: 2px;
        .el-divider__text {
          color: #fff;
          font-family: "Roboto", Sans-serif;
          font-size: 16px;
          background: #242222;
        }
      }
      .footer_main {
        display: flex;
        justify-content: space-around;
        width: 100%;
        margin: 0 auto;
        .main_details {
          padding-bottom: 14px;
          margin-top: 30px;
          .detail_title {
            margin-top: 15px;
            margin-bottom: 30px;
            font-size: 18px;
            color: #fff;
            direction: ltr;
            font-family: "Roboto", Sans-serif;
            font-weight: 700;
            letter-spacing: normal;
            text-align: left;
          }
          .detail_item {
            color: #ccc;
            font-size: 15px;
            font-weight: 400;
            letter-spacing: 0;
            text-align: center;
            margin: 5px 0;
            cursor: pointer;
          }
          .detail_item:hover {
            text-decoration: underline;
          }
          .bottom_imgs {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            img {
              display: inline-block;
              width: 180px;
              height: 46px;
              margin-bottom: 12px;
              cursor: pointer;
            }
          }
          .pointer {
            cursor: pointer;
          }
          .link_item {
            color: #aa0bc0;
            font-weight: 400;
            text-decoration: underline;
          }
        }
      }
    }

    .footer_main {
      display: flex;
      justify-content: space-around;
      width: 1200px;
      margin: 0 auto;
      .main_details {
        padding-bottom: 14px;
        .detail_title {
          margin-top: 19px;
          color: #000;
          direction: ltr;
          font-family: "Roboto", Sans-serif;
          font-size: 26px;
          font-weight: 900;
          line-height: 120%;
          letter-spacing: normal;
          text-align: left;
        }
        .detail_item {
          margin-top: 10px;
          color: #101112;
          direction: ltr;
          font-size: 16px;
          font-weight: 400;
          line-height: 150%;
          letter-spacing: 0;
          text-align: left;
          cursor: pointer;
        }
        .detail_item:hover {
          text-decoration: underline;
        }
        .bottom_imgs {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          img {
            display: inline-block;
            width: 180px;
            height: 46px;
            margin-bottom: 12px;
            cursor: pointer;
          }
        }
        .pointer {
          cursor: pointer;
        }
        .link_item {
          color: #aa0bc0;
          font-weight: 400;
          text-decoration: underline;
        }
      }
    }
    .footer_infos {
      display: flex;
      justify-content: center;
      padding-top: 13px;
      margin: 0 auto;
      background: #fff;
      .container {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1200px;
        margin-top: 60px;
        margin-bottom: 40px;
        .left_container {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          width: 280px;
          .logo {
            display: inline-block;
            max-width: 120px;
            margin-bottom: 25px;
          }
          .infos_title {
            width: 280px;
            padding-bottom: 13px;
            color: #000;
            font-size: 22px;
            font-weight: 500;
            text-align: center;
            border-bottom: 3px solid $mainColor;
          }
        }
        .right_desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
          .top_content {
            display: flex;
            align-items: center;
            width: 96%;
            height: 50px;
            color: #000;
            font-weight: bold;
            border: 4px solid #000;
            border-radius: 36px;
            .btn {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: 210px;
              height: 100%;
              color: #fff;
              font-size: 20px;
              background-color: #000;
              border-radius: 30px;
              cursor: pointer;
            }
            .text {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              flex: 1;
              font-size: 25px;
              font-weight: bolder;
            }
          }
          .content {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
            margin-top: 40px;
            .text {
              margin-right: 40px;
              color: #000;
              font-size: 26px;
              font-weight: 500;
            }
            .icon {
              margin-right: 8px;
            }
            .icon img {
              max-height: 32px;
            }
          }
        }
      }
    }
    .footer_incs {
      display: flex;
      justify-content: center;
      width: 100%;
      background: #fff;
      .incs_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        font-size: 20px;
        .insc {
          color: #101112;
          direction: ltr;
          font-size: 20px;
          font-weight: 800;
          letter-spacing: 0;
          text-align: center;
          span {
            font-weight: 800;
          }
        }
        .footer_links {
          display: inline-flex;
          justify-content: center;
          padding-bottom: 16px;
          font-size: 20px;
          a {
            color: $mainColor;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }

  .column-line {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #D0D7DE;
    &::after, &::before {
      content: '';
      display: inline-block;
      height: 1px;
      flex: 1;
      margin: 0 10px;
      background: #D0D7DE;
    }
  }

  .footer_bottom {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-top: 20px;
    background-color: #414141;
    .footer_desc {
      width: 1120px;
      padding: 10px;
      .top_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #242222;

        .left {
          width: 460px;
          h3 {
            margin-bottom: 40px;
            color: #fff;
            font-size: 28px;
            font-weight: bold;
          }
          .ekit_social_media {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0;
            .elementor-repeater-item {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: 40px;
              height: 40px;
              margin-right: 20px;
              border-radius: 50%;
              a {
                border-radius: 50%;
                color: #fff;
                &:hover {
                  background-color: #5e6d7e;
                  transition: all 0.4s ease;
                }
                i {
                  font-size: 30px;
                }
              }
            }
          }
        }
        .right {
          .paylist {
            display: flex;
            align-items: center;
            li {
              display: inline-flex;
              flex-direction: column;
              align-items: center;
              width: 135px;
              height: 84px;
              padding: 10px;
              color: #fff;
              font-size: 15px;
              i {
                display: inline-block;
                margin-bottom: 20px;
                font-size: 36px;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    .footer_incs {
      display: flex;
      justify-content: center;
      width: 100%;
      padding: 10px 0;
      .incs_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        font-size: 20px;
        .insc {
          color: #fff;
          direction: ltr;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0;
          text-align: center;
          span {
            font-weight: 600;
          }
        }
        .footer_links {
          display: inline-flex;
          justify-content: center;
          font-size: 16px;
          a {
            color: #fff;
            &:hover {
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
